import $ from 'jquery';
import {formatMoney} from '@shopify/theme-currency';
import ExtendedVariants from '../extended-variants';
// import Stock from '../stock';
// import Options from '../options';

const selectors = {
  comparePrice: '[data-compare-price]',
  comparePriceText: '[data-compare-text]',
  originalSelectorId: '[data-product-select]',
  priceWrapper: '[data-price-wrapper]',
  productJson: '[data-product-json]',
  productPrice: '[data-product-price]',
  singleOptionSelector: '[data-single-option-selector]',
};

const cssClasses = {
  hide: 'hide',
};

const BaseProduct = {
  onLoad() {
    this.init();
  },

  init() {
    this.$container = $(this.container);
    this.namespace = `.${this.id}`;
    this.productJson = $(selectors.productJson, this.$container).html();

    if (!this.productJson) {
      return;
    }

    this.productSingleObject = JSON.parse(this.productJson);

    const options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject,
    };

    this.childConfig = {
      $container: this.$container,
      namespace: this.namespace,
    };

    // this.variants = new ExtendedVariants(options);
    // this.stock = new Stock(this.childConfig);

    // const optionConfig = $.extend(options, {
    //   stock: this.stock.inventory,
    //   namespace: this.namespace,
    // });

    // this.productOptions = new Options(optionConfig);

    this.bind();
  },

  bind() {
    this.$container.on(
      `variantPriceChange${this.namespace}`,
      this.updateProductPrices.bind(this),
    );
    this.$container.on(`optionsChange${this.namespace}`, this.updateProductPrices.bind(this));
  },

  /**
   * Updates the DOM with specified prices
   */
  updateProductPrices(event) {
    const {variant} = event;

    if (!variant) {
      return;
    }

    const $comparePrice = $(selectors.comparePrice, this.$container);
    const $compareEls = $comparePrice.add(
      selectors.comparePriceText,
      this.$container,
    );

    $(selectors.productPrice, this.$container).html(
      formatMoney(variant.price, theme.moneyFormat),
    );

    if (variant.compare_at_price > variant.price) {
      $comparePrice.html(
        formatMoney(variant.compare_at_price, theme.moneyFormat),
      );
      $compareEls.removeClass(cssClasses.hide);
    } else {
      $comparePrice.html('');
      $compareEls.addClass(cssClasses.hide);
    }
  },

  /**
   * Event callback for Theme Editor `section:unload` event
   */
  onUnload() {
    this.$container.off(this.namespace);
  },
};

export default BaseProduct;
